import React from 'react'
import { Equipment } from '@/payload-types'
import { RichText } from '@payloadcms/richtext-lexical/react'
import { isMedia } from '@/lib/utils'
import Image from 'next/image'
import { Blocks } from '@/components'

interface EquipmentDetailProps {
  equipment: Equipment
}

function EquipmentDetail({ equipment }: Readonly<EquipmentDetailProps>) {
  const photo = equipment.image && isMedia(equipment.image) ? equipment.image : false
  return (
    <>
      {photo ? (
        <figure className="max-w-4xl mx-auto p-4">
          <Image
            className="rounded-lg"
            src={String(photo.url)}
            alt={photo.alt || equipment.title}
            width={Number(photo.width)}
            height={Number(photo.height)}
          />
        </figure>
      ) : null}
      <section className="max-w-4xl mx-auto p-4">
        {equipment.content && <RichText data={equipment.content} className="prose prose-neutral" />}
      </section>
      {equipment.blocks && <Blocks blocks={equipment.blocks} />}
    </>
  )
}

export { EquipmentDetail }
